import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { OturumSiniri } from "./oturum-siniri";
import { Uygulama } from "./Uygulama";
import { JetonSayfasi, jetonSayfasiniOku } from "./JetonSayfasi";
import { HataSiniri } from "./HataSiniri";
import { pwaBaslat } from "./pwa";
import "./stil.css";

const sorguIstemcisi = new QueryClient({
  defaultOptions: {
    queries: {
      // Ogrenci uygulamasi CEVRIMDISI calisir: eldeki veri "bayat" olsa da
      // gosterilir. Bos ekran yerine dunku program gosterilir.
      retry: 2,
      staleTime: 5 * 60_000,
      gcTime: 24 * 60 * 60_000,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      networkMode: "offlineFirst",
    },
    mutations: {
      // Mutasyonlar dogrudan gonderilmez; senkron kuyruguna yazilir.
      networkMode: "offlineFirst",
    },
  },
});

// Service worker kaydi — uretimde. Onceden uretiliyordu ama HIC
// CAGRILMIYORDU: `registerSW.js` dist icinde duruyor, kimse yuklemiyordu.
// Yani uygulama cevrimdisi acilmiyordu (31.07.2026'da fark edildi).
pwaBaslat();

const kok = document.getElementById("kok");
// G-AUT-08b — jeton ekranı oturum sorgusu ve onay kilidinden önce açılır.
const jetonSayfasi = jetonSayfasiniOku();
if (!kok) throw new Error("#kok bulunamadi");

createRoot(kok).render(
  <StrictMode>
    {/*
      HATA SINIRI EN DIŞTA. İçeride olsaydı kabuğun kendisi patladığında
      yine beyaz ekran kalırdı; ölçülen vaka da tam olarak buydu —
      `Onaylarim` çizimde patlayınca React BÜTÜN ağacı söktü.
      Gerekçenin tamamı `HataSiniri.tsx` içinde.
    */}
    <HataSiniri>
      <QueryClientProvider client={sorguIstemcisi}>
        <OturumSiniri>
          {jetonSayfasi && jetonSayfasi.akis !== "anket" ? (
            <JetonSayfasi sayfa={jetonSayfasi} />
          ) : (
            <Uygulama />
          )}
        </OturumSiniri>
      </QueryClientProvider>
    </HataSiniri>
  </StrictMode>,
);
